import { useEffect, useMemo, useState } from 'react';
import {
  readStorageJSON,
  removeStorageItem,
  writeStorageJSON,
} from '../utils/storage';

const resolvePersistedKey = (key, scopeKey) => {
  if (!scopeKey) return key;
  return `${key}:${scopeKey}`;
};

const usePersistedState = (key, defaultValue, options = {}) => {
  const {
    scopeKey = null,
    area = 'local',
  } = options || {};

  const storageKey = useMemo(
    () => resolvePersistedKey(key, scopeKey),
    [key, scopeKey],
  );

  const [state, setState] = useState(() => {
    return readStorageJSON(storageKey, { area, fallback: defaultValue });
  });

  useEffect(() => {
    setState(readStorageJSON(storageKey, { area, fallback: defaultValue }));
    // defaultValue is intentionally excluded so callers with inline [] / {} defaults do not reset on every render.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [area, storageKey]);

  useEffect(() => {
    if (state === undefined) {
      removeStorageItem(storageKey, { area });
      return;
    }
    writeStorageJSON(storageKey, state, { area });
  }, [area, state, storageKey]);

  return [state, setState];
};

export default usePersistedState;
